import { Visit } from '@core/model/visit/visit.model';
import { VisitRecord } from '@core/model/visit/visit-record.model';
import { IVisit } from './visit.interface';

export interface ICheckinResponse {
  visit: IVisit;
  visitRecord: VisitRecord;
}

export class CheckinResponse {
  visit: Visit;
  visitRecord: VisitRecord;

  constructor(data: ICheckinResponse) {
    if (!data) {
      return;
    }
    const { visit, visitRecord } = data;
    if (visit) {
      this.visit = new Visit(visit);
    }
    if (visitRecord) {
      this.visitRecord = visitRecord;
    }
  }
}
